import React from 'react';

import { useRouter } from 'next/navigation';

import Icon from '@OnArk/SVGs/Icon';
import Cookies from 'universal-cookie';

function LangPicker({ locale }: { locale: 'en' | 'es' }) {
  const router = useRouter();

  return (
    <div css={{ float: 'right', marginLeft: 'auto' }}>
      <Icon name="GLOBAL_World" size="20" />
      <button
        disabled={locale === 'en'}
        style={{ color: locale === 'en' ? '#ccc' : 'inherit' }}
        onClick={() => {
          new Cookies().set('onark-lang', 'en', {
            maxAge: 30 * 24 * 60 * 60 * 1000,
            path: '/',
          });
          router.refresh();
        }}
      >
        EN
      </button>{' '}
      |{' '}
      <button
        disabled={locale === 'es'}
        style={{ color: locale === 'es' ? '#ccc' : 'inherit' }}
        onClick={() => {
          new Cookies().set('onark-lang', 'es', {
            maxAge: 30 * 24 * 60 * 60 * 1000,
            path: '/',
          });
          router.refresh();
        }}
      >
        ES
      </button>
    </div>
  );
}

export default LangPicker;
